// An "inferno"-like colormap: black → purple → red → orange → pale yellow. 256 × RGB.
const STOPS: [number, number, number, number][] = [
  [0.0, 0, 0, 4], [0.15, 31, 12, 72], [0.3, 85, 15, 109], [0.45, 136, 34, 106],
  [0.6, 186, 54, 85], [0.72, 227, 89, 51], [0.84, 249, 140, 10], [0.93, 249, 201, 50], [1.0, 252, 255, 164],
];
export const LUT = new Uint8Array(256 * 3);
for (let i = 0; i < 256; i++) {
  const t = i / 255;
  let k = 0;
  while (k < STOPS.length - 2 && STOPS[k + 1][0] < t) k++;
  const [a, r0, g0, b0] = STOPS[k], [b, r1, g1, b1] = STOPS[k + 1];
  const f = (t - a) / (b - a);
  LUT[i * 3] = r0 + f * (r1 - r0);
  LUT[i * 3 + 1] = g0 + f * (g1 - g0);
  LUT[i * 3 + 2] = b0 + f * (b1 - b0);
}
